module.exports = __webpack_public_path__ + "static/media/DayCareEnviro.d8aafc6b.jpg";